import {fullDate, fullDateTime, time} from '@management-ui/core';
import moment from 'moment';
import * as React from 'react';
import {useContext} from 'react';
import {ServiceContext} from '../../../../components/Services';
import EngineerLabel from '../../components/EngineerLabel';
import ManagementTable from '../../components/ManagementTable';
import CalendarNoteForm from '../../forms/CalendarNoteForm';

const Table = () => {
  const services = useContext(ServiceContext);
  return (
    <ManagementTable
      title="Quick Allocations"
      addTitle="Add New Quick Allocation"
      editTitle="Edit Quick Allocation"
      columns={[
        {title: 'Description', field: 'description'},
        {
          title: 'Engineer', field: 'engineer', render: data => data.engineer ? (
            <EngineerLabel engineer={data.engineer}/>
          ) : 'Unallocated'
        },
        {title: 'Date', field: 'date', render: data => fullDate(data.date)},
        {title: 'Time', field: 'time', render: data => `${time(data.start_at)} - ${time(data.end_at)}`},
        {title: 'Expires', field: 'expires_at', render: data => data.expires_at ? fullDateTime(data.expires_at) : '-'}
      ]}
      loadData={async (query) => services.calendarNote.getTableNotes(query)}
      renderForm={(props, note, onSaved) => (
        <CalendarNoteForm
          {...props}
          note={note ?? {}}
          onSaved={onSaved}
        />
      )}
      tableProps={{
        options: {
          rowStyle: (note) => note.expires_at && moment(note.expires_at).isBefore(moment()) ? {
            opacity: 0.4
          } : {}
        }
      }}
    />
  )
};

export default Table;
